import React, { useState, useEffect } from 'react';
import './ResultListMenu.css';
import IconLinkout from './IconLinkout';
import IconVolume from './IconVolume';
import IconInfo from './IconInfo';
import LoadingSpinner from './LoadingSpinner';
import IconError from './IconError';

export default function ResultListMenu({
  feature,
  aiSearchMode,
  ardLink,
  handleReadResultsAloud,
  ttsLoading,
  ttsError,
  accordionInfo
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [visibleError, setVisibleError] = useState("");

  const getInfoButtonLabel = () => {
    if (feature === 'conversational') {
      return 'Filter-Info';
    }
    if (feature === 'search') {
      if (aiSearchMode === 'free-text') {
        return 'Filter-Info';
      }
      if (aiSearchMode === 'agentic') {
        return 'Agent Denkprozess';
      }
      if (aiSearchMode === 'ardonline') {
        return 'Suchergebnis-Info';
      }
      return 'Suchergebnis-Info';
    }
    return 'Suchergebnis-Info';
  };

  useEffect(() => {
    if (!ttsError) return;

    setVisibleError(ttsError);

    const timer = setTimeout(() => {
      setVisibleError("");
    }, 4000);

    return () => clearTimeout(timer);
  }, [ttsError]);

  const toggleAccordion = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
      <div className="pill-menu-wrapper">
        <div className="pill-menu">
          <a
            href={ardLink}
            className={`pill-button pill-link ${feature == "popular" ? "link--disabled" : ""}`}
            target="_blank" rel="noreferrer"
            onClick={(e) => {
              if (feature == "popular") e.preventDefault();
            }}>
            <span className="pill-icon"><IconLinkout /></span>
            <span className="pill-label">ARD Mediathek Treffer</span>
          </a>

          <button disabled={ttsLoading} className="pill-button" onClick={handleReadResultsAloud}>
            <span className="pill-icon">{ttsLoading ? <LoadingSpinner size={14} /> : <IconVolume size={14} />}</span>
            <span className="pill-label">Vorlesen</span>
          </button>

          <button
            className={`pill-button ${isOpen ? "pill-button-active" : ""}`}
            onClick={toggleAccordion}
            aria-expanded={isOpen}
            aria-controls="pill-accordion"
            disabled={!accordionInfo}
          >
            <span className="pill-icon"><IconInfo size={14} /></span>
            <span className="pill-label">{getInfoButtonLabel()}</span>
          </button>
        </div>

        {isOpen && (
          <div id="pill-accordion" className="pill-accordion">
            <div className="pill-accordion-content">
              {accordionInfo}
            </div>
          </div>
        )}
      </div>
      <div className="error-container">
        {visibleError && <span className="error-overlay"><IconError size={14} />{visibleError}</span>}
      </div>
    </>
  );
}